import { Col, Image } from 'antd'
import Container from './container'
import { StyledAboutUsTitle, StyledAboutUsWrapper, StyledParagraph } from './styles'

export default function Index ({ ...pageProps }) {
  return (
    <Container {...pageProps}>
      {({ paragraphs }) => (
        <StyledAboutUsWrapper justify='center' align='middle'>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <StyledAboutUsTitle>
              About Peri-Peri Charcoal <br /> Chicken & Sauce Bar
            </StyledAboutUsTitle>
            {paragraphs.map(paragraph => (
              <>
                <StyledParagraph key={paragraph}>{paragraph}</StyledParagraph>
                <br />
              </>
            ))}
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <Image preview={false} src='/images/about-us/about-us-frame.png' />
          </Col>
        </StyledAboutUsWrapper>
      )}
    </Container>
  )
}
